import React, { PureComponent, PropTypes } from 'react';
import DocumentTitle from 'react-document-title';
import { Route, Switch } from 'react-router';
import { connect } from 'react-redux';
import Media from 'react-media';
import { selectItems, getCenter, getId, locationProductType } from '../../redux/modules/browser/selectors';
import { loadBrowserItems, setBrowserType } from '../../redux/actions';

import FilterList from '../FilterList';
import ObjectDetails from '../ObjectDetails';

import BrowserMap from './BrowserMap';


import './Browser.scss';

class Browser extends PureComponent {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    activeId: PropTypes.number,
    center: PropTypes.object,
    locationProductType: PropTypes.string,
    loadBrowserItems: PropTypes.func.isRequired, 
    loading: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { locationProductType, loadBrowserItems, setBrowserType } = this.props;
    if (locationProductType) {
      setBrowserType(locationProductType);
    }
    loadBrowserItems();
  }

  render () {
    const {
      center,
      activeId,
      items,
      loading
    }  = this.props
    return (
      <div id="browser" className="align-self-stretch">
        <DocumentTitle title="Reklāmas vietas - e-BML" />
        <div className="row no-gutters contents">
          {(items || center) && (
            <Media query="(min-width: 576px)" render={() => (
              <div className="col d-flex"><BrowserMap hilighted={activeId} center={center} items={items} /></div>
            )}/>
          )}
          <Switch>
            <Route exact path="/browse/">
              <FilterList items={items} loading={loading} />
            </Route>
            <Route path="/browse/:id(\d+)/:productId(\d+)?" component={ObjectDetails} />
          </Switch>
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state, props) => ({
    items: selectItems(state, props),
    loading: state.browser.loading,
    center: getCenter(state, props),
    activeId: getId(state, props),
    locationProductType: locationProductType(state, props)
});


export default connect(
  mapStateToProps,
  {
    loadBrowserItems,
    setBrowserType
  }
)(Browser);




// WEBPACK FOOTER //
// ./src/scenes/Browser/index.js